import { render, staticRenderFns } from "./Navbarcrm.vue?vue&type=template&id=1f74d26e&"
import script from "./Navbarcrm.vue?vue&type=script&lang=js&"
export * from "./Navbarcrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports